import { shortcuts } from '@myua/api';
import React, { useEffect, useState } from 'react';
import { FakeCHNode } from '.';
import { Button } from '@myua/kit';
import { CHNodeIsFolder } from '../../../../../node';

const delay = (ms: number) =>
  new Promise((ok) => {
    setTimeout(ok, ms);
  });

export const CompressedDownloadLinkPlugin: React.FC<{
  node: FakeCHNode;
  meta?: { fileURLGetter: (path: string) => string };
}> = ({ node, meta }) => {
  const url = meta!.fileURLGetter(node.path);

  const [isLoading, setIsLoading] = useState(false);
  // Отказ бэкенда (403): дальше опрашивать нечего — ждать, пока разрешат, бессмысленно.
  const [denied, setDenied] = useState(false);
  const onClick = () => {
    setIsLoading(true);
  };

  useEffect(() => {
    return () => {
      setIsLoading(false);
      setDenied(false);
    };
  }, [node.name]);
  useEffect(() => {
    const abrt = new AbortController();
    async function run() {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        try {
          const result = await shortcuts.head({ url, signal: abrt.signal });
          if (result.status === 200) {
            window.open(url, '_blank');
            setIsLoading(false);
            break;
          }
          // 202 = архив ещё распаковывается на бэкенде, ждём и спрашиваем снова.
          // Отказ в доступе (403 — напр. лицензии шрифтов архива не одобрены) ретраить
          // нельзя: иначе кнопка бесконечно висит в «Loading...» и раз в секунду
          // дёргает сервер. Кнопки Open у такого архива быть не должно (её скрывает
          // MediaCompressed по openEntriesAllowed), но состояние могло устареть —
          // напр. юрист отклонил лицензию, пока страница была открыта.
          if (result.status === 403) {
            setDenied(true);
            setIsLoading(false);
            break;
          }
        } catch (error) {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
          const failure = (error as any)?.error;
          if (failure?.name === 'AbortError') {
            setIsLoading(false);
            break;
          }
          // Тот же 403, но пришедший исключением (зависит от статуса в обёртке запроса).
          if (failure?.status === 403 || (error as any)?.status === 403) {
            setDenied(true);
            setIsLoading(false);
            break;
          }
        }
        await delay(1000);
      }
    }
    if (isLoading) {
      void run();
    }
    return () => {
      abrt.abort();
    };
  }, [isLoading, url]);

  if (CHNodeIsFolder(node)) return null;

  return (
    <span className="gen-preview__compressed-link">
      <Button
        type="primary"
        size="small"
        disabled={denied}
        title={denied ? 'This file is unavailable for download' : undefined}
        onClick={onClick}
      >
        {denied ? 'Unavailable' : isLoading ? 'Loading...' : 'Open'}
      </Button>
    </span>
  );
};
